export const Colors = {
  mainColor: '#f00',
  lightBlue: '#899ed1',
  extraLightBlue: '#D0E5FF',
  yellow: '#E7CF49',
  darkDarkBlue: 'rgb(48, 90, 166)',
  newYellow: '#E7CF48',
  sea: '#025072',
  newLightBlue: '#0384bc',
  black: '#000',
  white: '#fff',
  verbaliaLight: '#A47AB5',
  lightGreen: '#97ad45',
  gray: '#f5f5f5',
  lighterMainColor: '#F5F5F5',
  accent1: '#0B1C2D',
  accent2:
    'linear-gradient(0deg, #4DA3FF 0%, #4DA3FF 100%), linear-gradient(121deg, #4DA3FF 3.77%, #0B1C2D 98.51%)',
  mainGradient: 'linear-gradient(121deg, #4DA3FF 3.77%, #0B1C2D 98.51%)',
};
